import { UnreachableFunction } from 'ui/base/types';
import { Theme, ThemedStyles } from 'ui/base/theme';

import { PlanFirewallBilling, PlanFirewallPackage } from 'services/accounts/types';

import packageIconImageBasicMidnight from './plan_firewall_icons/packages/basic/dark.png';
import packageIconImageBasicDaylight from './plan_firewall_icons/packages/basic/light.png';
import packageIconImageBusinessMidnight from './plan_firewall_icons/packages/business/dark.png';
import packageIconImageBusinessDaylight from './plan_firewall_icons/packages/business/light.png';
import packageIconImageEnterpriseMidnight from './plan_firewall_icons/packages/enterprise/dark.png';
import packageIconImageEnterpriseDaylight from './plan_firewall_icons/packages/enterprise/light.png';

import billingIconImageMonthlyMidnight from './plan_firewall_icons/billing/monthly/dark.png';
import billingIconImageMonthlyDaylight from './plan_firewall_icons/billing/monthly/light.png';
import billingIconImageYearlyMidnight from './plan_firewall_icons/billing/yearly/dark.png';
import billingIconImageYearlyDaylight from './plan_firewall_icons/billing/yearly/light.png';
import billingIconImageBiennialMidnight from './plan_firewall_icons/billing/biennial/dark.png';
import billingIconImageBiennialDaylight from './plan_firewall_icons/billing/biennial/light.png';
import billingIconImageTriennialMidnight from './plan_firewall_icons/billing/triennial/dark.png';
import billingIconImageTriennialDaylight from './plan_firewall_icons/billing/triennial/light.png';
import billingIconImageLifetimeMidnight from './plan_firewall_icons/billing/lifetime/dark.png';
import billingIconImageLifetimeDaylight from './plan_firewall_icons/billing/lifetime/light.png';

export type PlanFirewallPackageIconStyles = {
  basic: string;
  business: string;
  enterprise: string;
};

export type PlanFirewallBillingIconStyles = {
  monthly: string;
  yearly: string;
  biennial: string;
  triennial: string;
  lifetime: string;
};

export const themedPlanFirewallPackageIconStyles: ThemedStyles<PlanFirewallPackageIconStyles> = {
  [Theme.DAYLIGHT]: {
    basic: packageIconImageBasicDaylight,
    business: packageIconImageBusinessDaylight,
    enterprise: packageIconImageEnterpriseDaylight,
  },
  [Theme.MIDNIGHT]: {
    basic: packageIconImageBasicMidnight,
    business: packageIconImageBusinessMidnight,
    enterprise: packageIconImageEnterpriseMidnight,
  },
};

export const themedPlanFirewallBillingIconStyles: ThemedStyles<PlanFirewallBillingIconStyles> = {
  [Theme.DAYLIGHT]: {
    monthly: billingIconImageMonthlyDaylight,
    yearly: billingIconImageYearlyDaylight,
    biennial: billingIconImageBiennialDaylight,
    triennial: billingIconImageTriennialDaylight,
    lifetime: billingIconImageLifetimeDaylight,
  },
  [Theme.MIDNIGHT]: {
    monthly: billingIconImageMonthlyMidnight,
    yearly: billingIconImageYearlyMidnight,
    biennial: billingIconImageBiennialMidnight,
    triennial: billingIconImageTriennialMidnight,
    lifetime: billingIconImageLifetimeMidnight,
  },
};

export function getPlanFirewallBillingIcon(styles: PlanFirewallBillingIconStyles, billing_type: PlanFirewallBilling) {
  switch (billing_type) {
    case PlanFirewallBilling.MONTHLY:
      return styles.monthly;
    case PlanFirewallBilling.YEARLY:
      return styles.yearly;
    case PlanFirewallBilling.BIENNIAL:
      return styles.biennial;
    case PlanFirewallBilling.TRIENNIAL:
      return styles.triennial;
    case PlanFirewallBilling.LIFETIME:
      return styles.lifetime;
    default:
      return UnreachableFunction(billing_type);
  }
}

export function getPlanFirewallPackageIcon(styles: PlanFirewallPackageIconStyles, package_type: PlanFirewallPackage) {
  switch (package_type) {
    case PlanFirewallPackage.BASIC:
      return styles.basic;
    case PlanFirewallPackage.BUSINESS:
      return styles.business;
    case PlanFirewallPackage.ENTERPRISE:
      return styles.enterprise;
    default:
      return UnreachableFunction(package_type);
  }
}
